import { useQuery } from '@tanstack/react-query'
import { apiFetch } from './client'

/**
 * One row from ``GET /api/admin/billing/audit-log``.
 *
 * ``before_state`` / ``after_state`` / ``metadata`` are arbitrary
 * JSON blobs the backend serializes per-action; the UI displays them
 * verbatim in a collapsible details element.
 */
export interface AuditLogEntry {
  id: string
  timestamp: number
  actor_user_id: string
  actor_email: string
  actor_source: 'session' | 'pat' | 'oauth'
  actor_is_superadmin: boolean
  target_org_id: string | null
  action: string
  endpoint: string
  request_id: string | null
  before_state: Record<string, unknown> | null
  after_state: Record<string, unknown> | null
  metadata: Record<string, unknown> | null
  ip_address: string | null
  user_agent: string | null
}

export interface AuditLogResponse {
  items: AuditLogEntry[]
  limit: number
  offset: number
}

export interface AuditLogFilters {
  actorUserId?: string
  targetOrgId?: string
  action?: string
  since?: number
  until?: number
  limit?: number
  offset?: number
}

export function useAuditLog(filters: AuditLogFilters) {
  const qs = new URLSearchParams()
  if (filters.actorUserId) qs.set('actor_user_id', filters.actorUserId)
  if (filters.targetOrgId) qs.set('target_org_id', filters.targetOrgId)
  if (filters.action) qs.set('action', filters.action)
  if (filters.since !== undefined) qs.set('since', String(filters.since))
  if (filters.until !== undefined) qs.set('until', String(filters.until))
  qs.set('limit', String(filters.limit ?? 50))
  qs.set('offset', String(filters.offset ?? 0))
  return useQuery({
    queryKey: ['admin', 'billing', 'audit-log', qs.toString()],
    queryFn: () =>
      apiFetch<AuditLogResponse>(`/api/admin/billing/audit-log?${qs.toString()}`),
  })
}
